import moment from 'moment';
import * as yup from 'yup';

import { validateCompanyDocument } from 'utils/validators';

declare module 'yup' {
  interface MixedSchema {
    equalTo(ref: any, msg?: string): yup.MixedSchema;
  }

  interface StringSchema {
    companyDocument(documentType: string): yup.StringSchema;
    phone(): yup.StringSchema;
    validDate(date: Date): yup.StringSchema;
    code(): yup.StringSchema;
    validPassportValidationDate(): yup.StringSchema;
    noPlusSign(): yup.StringSchema;
  }
}

yup.addMethod<yup.MixedSchema>(
  yup.mixed,
  'equalTo',
  (ref: any, msg?: string): yup.MixedSchema =>
    yup.mixed().test({
      name: 'equalTo',
      exclusive: false,
      message: msg || 'error.equalTo',
      params: {
        reference: ref.path,
      },
      test(value) {
        return value === this.resolve(ref);
      },
    }),
);

yup.addMethod<yup.StringSchema>(yup.string, 'companyDocument', function (documentType: string): yup.StringSchema {
  const isValid = (str?: string) => !str || validateCompanyDocument(str, documentType);
  return this.test('companyDocument', 'error.document', isValid);
});

yup.addMethod<yup.StringSchema>(yup.string, 'phone', function (): yup.StringSchema {
  const isValid = (str?: string) => {
    if (!str) return true;

    if (str.length > 25) return false;

    const regex = new RegExp(/^[\d+(\-?)+(.?)+((?)+()?)+(\s?)+(+?)+(/?)]+[\d]$/g);
    return regex.test(str);
  };
  return this.test('phone', 'error.phone', isValid);
});

yup.addMethod<yup.StringSchema>(yup.string, 'validDate', function (date: Date): yup.StringSchema {
  const isValid = (str?: string) => {
    const isValidDate = moment(str, 'DD/MM/YYYY', true).isValid();
    const dateFromValidation = moment(date).unix();
    const dateFromInput = moment(str, 'DD/MM/YYYY').unix();
    const todayDate = moment().unix();

    return !str || (dateFromValidation < dateFromInput && isValidDate && dateFromInput < todayDate);
  };
  return this.test('validDate', 'error.date', isValid);
});

yup.addMethod<yup.StringSchema>(yup.string, 'validPassportValidationDate', function (): yup.StringSchema {
  const isValid = (str?: string) => {
    const isValidDate = moment(str, 'DD/MM/YYYY', true).isValid();

    return !str || isValidDate;
  };

  return this.test('validPassportValidationDate', 'error.date', isValid);
});

yup.addMethod<yup.StringSchema>(yup.string, 'code', function (): yup.StringSchema {
  const isValid = (str?: string) => {
    if (!str) {
      return true;
    }

    const valid = str.match(/^[0-9]+$/);

    return !!valid;
  };
  return this.test('code', 'error.code', isValid);
});

yup.addMethod<yup.StringSchema>(yup.string, 'noPlusSign', function (email: string): yup.StringSchema {
  const isValid = (str?: string) => !str || !str.includes('+');
  return this.test('noPlusSign', 'error.noPlusSign', isValid);
});
